import { c as _c } from "react/compiler-runtime";
import React from "react";
import elements from "./IntroSection.module.scss";
export const IntroSection: React.FC<{
  heading: string;
  paragraph: string;
}> = t0 => {
  const $ = _c(7);
  const {
    heading,
    paragraph
  } = t0;
  let t1;
  if ($[0] !== heading) {
    t1 = <div><h3>{heading}</h3></div>;
    $[0] = heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== paragraph) {
    t2 = <div><p>{paragraph}</p></div>;
    $[2] = paragraph;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={elements.introsection}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};